import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { components } from "@/api/types.gen";
import type { DataResponse } from "@/api/schemas";

export type TovarFarba = components["schemas"]["TovarFarbaItem"];

/**
 * Farby CRC pri povrchu CO (KOLO 230) — zo súboru cenníka CRC, ktorý
 * platí na serveri; menia sa len s novým cenníkom.
 */
export function useTovarFarby(): UseQueryResult<TovarFarba[]> {
  return useQuery({
    queryKey: ["cennik", "tovar-farby"] as const,
    queryFn: async () => {
      const { data } = await api.get<DataResponse<TovarFarba[]>>("/cennik/tovar-farby");
      return data.data;
    },
    staleTime: 60 * 60 * 1000,
  });
}
